import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Checkbox } from '../ui/checkbox';
import { cn } from '../../lib/utils';
import { ChevronRight, TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';
import CategoriaSelect from './CategoriaSelect';
import { fmtPrezzo, fmtUm, fmtDataIt, fmtVariazione, coloreVariazione } from '../../lib/acquisti';

/** Riga del prezzario: prezzo, categoria in linea e selezione multipla. */
export const PrezzarioItem = ({
  p, categorie, isAdmin, selezione, selezionato, onToggle, onApri, onCategoria, salvando,
}) => {
  const variazione = fmtVariazione(p.variazione_pct);
  const categoria = p.categoria_effettiva || p.categoria;
  const daClassificare = !categoria;

  return (
    <Card
      className={cn(
        'cursor-pointer transition-colors',
        daClassificare && 'border-amber-400 bg-amber-50/50',
        selezionato && 'border-primary ring-1 ring-primary bg-primary/5',
        !daClassificare && !selezionato && 'hover:border-primary/40'
      )}
      onClick={selezione ? onToggle : onApri}
      data-testid={`prezzario-item-${p.id}`}
    >
      <CardContent className="p-3 space-y-2">
        <div className="flex items-start gap-3">
          {selezione && (
            <Checkbox
              checked={selezionato}
              className="mt-1 shrink-0"
              data-testid={`prezzario-check-${p.id}`}
            />
          )}
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold leading-snug">{p.descrizione}</p>
            <p className="text-xs text-muted-foreground truncate">
              {p.fornitore_nome}
              {p.codice_articolo ? ` · cod. ${p.codice_articolo}` : ''}
            </p>
            <p className="text-xs text-muted-foreground">
              Ultimo acquisto {fmtDataIt(p.ultima_data)} · {p.n_acquisti} acquisti
            </p>
          </div>
          <div className="text-right shrink-0">
            <p className="text-base font-bold tabular-nums">{fmtPrezzo(p.ultimo_prezzo)}</p>
            <p className="text-[11px] text-muted-foreground">{fmtUm(p.um_originale, p.um_norm)}</p>
            {variazione && (
              <p className={`text-xs font-semibold flex items-center justify-end gap-1 ${coloreVariazione(p.variazione_pct)}`}>
                {p.variazione_pct > 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                {variazione}
              </p>
            )}
          </div>
          {!selezione && <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />}
        </div>

        <div
          className="flex items-center justify-between gap-2 pt-2 border-t"
          onClick={(e) => e.stopPropagation()}
        >
          <span className={cn(
            'text-[11px] uppercase tracking-wide flex items-center gap-1',
            daClassificare ? 'text-amber-700 font-semibold' : 'text-muted-foreground'
          )}>
            {daClassificare && <AlertCircle className="w-3 h-3" />}
            {daClassificare ? 'Da classificare' : 'Categoria'}
          </span>
          {isAdmin && !selezione ? (
            <CategoriaSelect
              valore={categoria}
              categorie={categorie}
              onChange={(c) => onCategoria(p, c)}
              disabled={salvando}
              testid={`prezzario-categoria-${p.id}`}
              className="h-8 w-[180px]"
            />
          ) : (
            <Badge
              variant={categoria ? 'secondary' : 'outline'}
              className={cn('text-[10px]', daClassificare && 'border-amber-500 text-amber-700')}
              data-testid={`prezzario-categoria-badge-${p.id}`}
            >
              {categoria || 'DA CLASSIFICARE'}
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PrezzarioItem;
